// turning ai2html's output into a module allows
// webpack to apply hot module replacement.
// we obviously want to bake it into the html in production
// that's why we're conditionally requiring it

import { Child } from 'pym.js';
// import ai2html from './ai2html-graphic.html';
import * as d3 from 'd3';
import meta from './data/meta.json';

import Zion from './utils/Zion';

// polyfills
// import fetch from 'unfetch';
import './utils/polyfills'; // (includes Array.findIndex && Array.find)

// utils
import { stylePremium } from './utils/helpers';

// styles
import './styles/graphic.scss';

const mapboxgl = require('mapbox-gl');

const pkg = require('../package.json');

let ai2html = null;

if (process.env.NODE_ENV === 'development') {
  // turning ai2html's output into a module allows
  // webpack to apply hot module replacement.
  // we obviously want to bake it into the html in production
  // that's why we're conditionally requiring it
  ai2html = require('./ai2html-graphic.html');
}

// eslint-disable-next-line  no-use-before-define
window.pymChild = new Child({ renderCallback: draw, id: pkg.name });

console.clear();

window.onload = () => {
  // necessary evil for right now

  if (process.env.NODE_ENV === 'development') {
    Object.keys(meta).forEach((id) => {
      const node = document.querySelector(`.${id}`);

      if (node) {
        node.innerHTML = meta[id];
      }
    });
  }

  const { pymChild } = window;
  pymChild.sendHeight();

  // If embedded, send Zion page view event
  if (window.pymChild.parentUrl) {
    const zion = new Zion(pkg.name, pymChild.parentUrl.split('?')[0]);
  }
};

const CNNPolitics = false;
const CNNBusiness = false;

stylePremium(CNNPolitics, CNNBusiness);

function draw() {
  if (process.env.NODE_ENV === 'development') {
    // the code below applies the ai2html
    // during development mode.

    const figure = document.querySelector('#ai2html-graphic');
    figure.innerHTML = ai2html;

    // If you want to write code for this graphic,
    // move this stuff outside the if block that it's in.
  }
}

d3.timeFormatDefaultLocale({
  periods: ['a.m.', 'p.m.'],
  days: [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
  ],
  shortDays: ['Sun', 'Mon', 'Tues', 'Wed', 'Thurs', 'Fri', 'Sat'],
  months: [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ],
  shortMonths: [
    'Jan.',
    'Feb.',
    'March',
    'April',
    'May',
    'June',
    'July',
    'Aug.',
    'Sept.',
    'Oct.',
    'Nov.',
    'Dec.',
  ],
});


// MAKE MAP
const us_state_to_abbrev = {
  Alabama: 'AL',
  Alaska: 'AK',
  Arizona: 'AZ',
  Arkansas: 'AR',
  California: 'CA',
  Colorado: 'CO',
  Connecticut: 'CT',
  Delaware: 'DE',
  Florida: 'FL',
  Georgia: 'GA',
  Hawaii: 'HI',
  Idaho: 'ID',
  Illinois: 'IL',
  Indiana: 'IN',
  Iowa: 'IA',
  Kansas: 'KS',
  Kentucky: 'KY',
  Louisiana: 'LA',
  Maine: 'ME',
  Maryland: 'MD',
  Massachusetts: 'MA',
  Michigan: 'MI',
  Minnesota: 'MN',
  Mississippi: 'MS',
  Missouri: 'MO',
  Montana: 'MT',
  Nebraska: 'NE',
  Nevada: 'NV',
  'New Hampshire': 'NH',
  'New Jersey': 'NJ',
  'New Mexico': 'NM',
  'New York': 'NY',
  'North Carolina': 'NC',
  'North Dakota': 'ND',
  Ohio: 'OH',
  Oklahoma: 'OK',
  Oregon: 'OR',
  Pennsylvania: 'PA',
  'Rhode Island': 'RI',
  'South Carolina': 'SC',
  'South Dakota': 'SD',
  Tennessee: 'TN',
  Texas: 'TX',
  Utah: 'UT',
  Vermont: 'VT',
  Virginia: 'VA',
  Washington: 'WA',
  'West Virginia': 'WV',
  Wisconsin: 'WI',
  Wyoming: 'WY',
  'District of Columbia': 'DC',
  'American Samoa': 'AS',
  Guam: 'GU',
  'Northern Mariana Islands': 'MP',
  'Puerto Rico': 'PR',
  'United States Minor Outlying Islands': 'UM',
  'U.S. Virgin Islands': 'VI',
};

const container = d3.select('#graphic');
container.html('');

const mq = window.matchMedia('(min-width: 420px)');

container.append('div')
  .attr('id', 'map');

if (mq.matches) {
  d3.select('#map').attr('style', 'width: 100%; height: 500px;');
} else {
  d3.select('#map').attr('style', 'width: 100%; height: 300px;');
}


mapboxgl.accessToken = 'pk.eyJ1IjoiY25uZGlnaXRhbCIsImEiOiJiYjIwMTgxNDZmNjgyODllMjAxYTYwOTAxYmY2MzI2MyJ9.8F6TQITXymFzCXy8tBqGgg';

// Parse query parameters for zoom and center overrides
const urlParams = new URLSearchParams(window.location.search);
const paramZoom = urlParams.get('zoom') ? parseFloat(urlParams.get('zoom')) : null;
const paramLat = urlParams.get('lat') ? parseFloat(urlParams.get('lat')) : null;
const paramLng = urlParams.get('lng') ? parseFloat(urlParams.get('lng')) : null;

// Default values
const defaultCenter = [-95, 39.5];
const defaultZoom = 3.2;

// Use query params if provided, otherwise use defaults
const mapCenter = (paramLat !== null && paramLng !== null) ? [paramLng, paramLat] : defaultCenter;
const mapZoom = paramZoom !== null ? paramZoom : defaultZoom;

const map = new mapboxgl.Map({
  container: 'map',
  style: 'mapbox://styles/cnndigital/clq432mvc019m01qm3htp3bre',
  // style: 'mapbox://styles/cnndigital/clq3zd9kl003h01pd2fl6hr7w',
  center: mapCenter,
  zoom: mapZoom,
  bearing: 0,
  scrollZoom: false,
  dragRotate: false,
  logoPosition: 'bottom-right',
  touchPitch: false,
  interactive: true,
  projection: 'albers',
});

// Only apply responsive zoom if no zoom was specified via query param
if (paramZoom === null) {
  if (mq.matches) {
    map.setZoom(3.3); // set map zoom level for desktop size
  } else {
    map.setZoom(2.3); // set map zoom level for mobile size
  }
}


const nav = new mapboxgl.NavigationControl({
  showCompass: false,
});
map.addControl(nav, 'top-right');


map.on('load', () => {
  d3.json('https://ix.cnn.io/data/wx-winter-alerts/alerts.geojson').then((data) => {
    // Function to create "countyState" property and filter based on "alert" and "priorityList"
    function processGeoJSON(featureCollection, priorityList) {
      const uniqueFeatures = {};

      // Helper to get priority index, treating unknown alerts as lowest priority
      const getPriority = (alert) => {
        const index = priorityList.indexOf(alert);
        return index === -1 ? Infinity : index;
      };

      featureCollection.features.forEach((feature) => {
        // Create "countyState" property
        const countyState = `${feature.properties.name.toLowerCase().replace(/\s/g, '_')}_${feature.properties.state.toLowerCase()}`;
        feature.properties.countyState = countyState;

        // Check for uniqueness based on "countyState"
        if (!uniqueFeatures[countyState] || getPriority(feature.properties.alert) < getPriority(uniqueFeatures[countyState].properties.alert)) {
          uniqueFeatures[countyState] = feature;
        }
      });

      // Create a new GeoJSON Feature Collection with unique features
      const uniqueFeatureCollection = {
        type: 'FeatureCollection',
        features: Object.values(uniqueFeatures),
      };

      return uniqueFeatureCollection;
    }

    // Example priority list
    const priorityList = ['Blizzard Warning', 'Ice Storm Warning', 'Lake Effect Warning', 'Winter Storm Warning',
      'Extreme Cold Warning', 'Winter Storm Watch', 'Extreme Cold Watch', 'Winter Weather Advisory', 'Cold Weather Advisory'];

    // Process the GeoJSON feature collection
    const result = processGeoJSON(data, priorityList);


    const dataFeatures = data.features;
    // extract properties
    const dataSimple = dataFeatures.map(a => a.properties);

    const dataByState = Object.values(dataSimple.reduce((acc, { state, alert, population }) => {
      const key = `${state}_${alert}`; // unique combination of state and alert
      acc[key] = acc[key] || { state, alert, population: 0 };
      acc[key].population += population;
      return acc;
    }, {}));

    const statesObject = Object.groupBy(dataByState, ({ state }) => state);
    const statesArray = Object.keys(statesObject).map(key => ({ state: key, alerts: statesObject[key] }));


    if (statesArray.length == 1) {
      d3.select('#intro-dek').html('Today, there is <span id="rainbow"><span id="total-states">X</span> state</span> with weather advisories, watches or warnings across the US.');
    } else {
      d3.select('#intro-dek').html('Today, there are <span id="rainbow"><span id="total-states">X</span> states</span> with weather advisories, watches or warnings across the US.');
    }

    d3.select('#total-states').html(statesArray.length.toLocaleString());

    console.log(result);

    map.addSource('counties', {
      type: 'geojson',
      data: result,
    });

    const colorMap = {
      'Blizzard Warning': '#c52622',
      'Blizzard Watch': '#c52622',
      'Wind Chill Warning': '#f4d064',
      'Wind Chill Watch': '#f4d064',
      'Lake Effect Snow Warning': '#ff6c46',
      'Lake Effect Snow Watch': '#ff6c46',
      'Winter Storm Warning': '#b74dbc',
      'Winter Storm Watch': '#b74dbc',
      'Ice Storm Warning': '#53a796',
      'Winter Weather Advisory': '#52a797',
      'Extreme Cold Watch': '#b6c9ef',
      'Extreme Cold Warning': '#4065d8',
      'Cold Weather Advisory': '#999999',
    };

    map.addLayer({
      id: 'counties',
      source: 'counties',
      type: 'fill',
      paint: {
        'fill-color': [
          'match',
          ['get', 'alert'],
          'Blizzard Warning', colorMap['Blizzard Warning'],
          'Blizzard Watch', colorMap['Blizzard Watch'],
          'Wind Chill Warning', colorMap['Wind Chill Warning'],
          'Wind Chill Watch', colorMap['Wind Chill Watch'],
          'Lake Effect Snow Warning', colorMap['Lake Effect Snow Warning'],
          'Lake Effect Snow Watch', colorMap['Lake Effect Snow Watch'],
          'Winter Storm Warning', colorMap['Winter Storm Warning'],
          'Winter Storm Watch', colorMap['Winter Storm Watch'],
          'Ice Storm Warning', colorMap['Ice Storm Warning'],
          'Winter Weather Advisory', colorMap['Winter Weather Advisory'],
          'Extreme Cold Watch', colorMap['Extreme Cold Watch'],
          'Extreme Cold Warning', colorMap['Extreme Cold Warning'],
          'Cold Weather Advisory', colorMap['Cold Weather Advisory'],
          '#000',
        ],
        'fill-opacity': [
          'match',
          ['get', 'alert'],
          'Blizzard Warning', 0.8,
          'Blizzard Watch', 0.4,
          'Wind Chill Warning', 0.8,
          'Wind Chill Watch', 0.4,
          'Lake Effect Snow Warning', 0.8,
          'Lake Effect Snow Watch', 0.4,
          'Winter Storm Warning', 0.8,
          'Winter Storm Watch', 0.4,
          'Ice Storm Warning', 0.8,
          'Winter Weather Advisory', 0.4,
          'Extreme Cold Watch', 0.4,
          'Extreme Cold Warning', 0.8,
          'Cold Weather Advisory', 0.4,
          1,
        ],
      },
    });

    map.addControl(new mapboxgl.AttributionControl(), 'top-left');

    // Create a popup, but don't add it to the map yet.
    const popup = new mapboxgl.Popup({
      closeButton: false,
      closeOnClick: false,
    });

    map.on('mousemove', 'counties', (e) => {
      // Change the cursor style as a UI indicator.
      map.getCanvas().style.cursor = 'pointer';

      const { alert } = e.features[0].properties;
      const { name } = e.features[0].properties;
      const { state } = e.features[0].properties;
      const { population } = e.features[0].properties;

      const stateAbbr = us_state_to_abbrev[state];

      // Copy coordinates array.
      // const coordinates = e.features[0].geometry.coordinates.slice();
      // const { description } = e.features[0].properties;

      // // Ensure that if the map is zoomed out such that multiple
      // // copies of the feature are visible, the popup appears
      // // over the copy being pointed to.
      // while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
      //   coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
      // }

      const alert2 = alert.replace(/\s+/g, '_').toLowerCase();
      const population2 = population.toLocaleString();


      const html2 = `<div><span class='toolHed'>${name}, ${stateAbbr}</span></div>
      <table>
      <tr>
        <td class='tdLeft alertRow'><span class='alertRect ${alert2}' style='background-color: ${colorMap[alert]};'></span> ${alert}</td>
      </tr>
      <tr>
        <td class='tdLeft'>Pop. under alert:</td>
        <td class='tdRight'>${d3.format(',')(population2)}</td>
      </tr>
      </table>`;

      const html = `<b>${name}, ${stateAbbr}</b><br><p>${alert}</p><br><p>${population}</p>`;
      // Populate the popup and set its coordinates
      // based on the feature found.
      popup.setLngLat(e.lngLat).setHTML(html2).addTo(map);
    });

    map.on('mouseleave', 'counties', () => {
      map.getCanvas().style.cursor = '';
      popup.remove();
    });

    map.on('move', () => {
      const center = map.getCenter();
      const zoom = map.getZoom();
      const { lat } = center;
      const { lng } = center;
      const url = `?lat=${lat}&lng=${lng}&zoom=${zoom}`;
      console.log(url);
    });


    const updateTime = d3.timeParse('%Y-%m-%dT%H:%M:%S%Z')(data.timestamp);

    setTimeout(() => {
      d3.select('#timestamp')
        .text(`Updated ${d3.timeFormat('%-I:%M %p on %b %-d, %Y')(updateTime)}`);
    }, 1000);
  });
});
